<pr-tag-list
  [tags]="eventTags$ | async"
  (tagAdded)="addTag($event)"
 />
